import * as React from 'react';
import { SVGProps } from 'react';

const SvgPlus = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.035 11H20v2H4.035v-2z" />
    <path d="M11.019 4h1.996v16h-1.996V4z" />
  </svg>
);

export default SvgPlus;
